exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn[data-v-af6cf85e]{position:absolute;left:0;right:0;bottom:0;z-index:100;display:flex;-webkit-display:flex;width:90%;max-width:400px;height:50px;border:none;border-radius:30px;-webkit-border-radius:30px;letter-spacing:.5px;font-size:16px;color:#fff;font-weight:700;margin:10px auto;box-shadow:0 5px 5px 1px #a9a9a9}.btn i[data-v-af6cf85e]{font-size:30px;position:absolute;top:50%;left:10%;transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%)}.btn p[data-v-af6cf85e]{display:flex;justify-content:center;align-items:center;-webkit-display:flex;-webkit-justify-content:center;-webkit-align-items:center;margin:0;width:100%}@media screen and (max-width:320px){.btn[data-v-af6cf85e]{height:40px;font-size:14px}.btn i[data-v-af6cf85e]{font-size:25px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-af6cf85e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/buttons/ScanAnotherCode.vue
// module id = 95
// module chunks = 0